import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

interface ApiBaseServiceConsData {
  static: {
    url: string;
  };
}

export abstract class ApiBaseService<ST> {
  protected readonly _httpClient = inject(HttpClient);

  protected readonly _staticUrl: (typeof this._consData)['static']['url'] =
    this._consData.static.url;

  public readonly dataStatic$: Observable<ST[]> = this._httpClient
    .get<ST[]>(this._staticUrl)
    .pipe(shareReplay());

  constructor(private _consData: ApiBaseServiceConsData) {}
}
